import axios from "axios";
const basePath = process.env.VUE_APP_HZMB_GH_BASE_PATH;

/**
 * 獲取通知訊息
 * @param {*} id
 * @param {*} serviceType
 * @param {*} messageType
 * @param {*} parameters
 */
const message = (id, serviceType, messageType, parameters = {}) => {
  return axios
    .post(
      `${basePath}/protected/api/v1/application/hzmbH/preview-message`,
      parameters,
      {
        params: { id, serviceType, messageType },
      }
    )
    .then((res) => res.data);
};

export default {
  message,
};
